// https://www.youtube.com/watch?v=Hf4MJH0jDb4


import React from "react";
import { triggerAlert } from "../Partials/AlertModal";

const Logout = () => {

  triggerAlert({
    show: true,
    title: "Logout",
    message: "Are you sure?",
    closeOnTouchOutside: true,
    closeOnHardwareBackPress: true,
    showCancelButton: true,
    cancelText: "Stay",
    onCancelPressed: () => {
      triggerAlert();
    },
    showConfirmButton: true,
    confirmButtonColor: window.main.theme.colors.caution,
    confirmText: "Logout",
    onConfirmPressed: async () => {
      triggerAlert();
        await window.main.axios.post(window.main.api.logout);
        window.main.lib.setUserProfile({});
        window.main.lib.setTempIsLoggedin(false);
        window.main.lib.setTempIsSessionChecked(true);
        window.main.lib.triggerMainState();
        window.main.lib.setCurrentView("login");
        window.main.lib.setLoadingState(false);
      // // window.main.lib.setTempCurrentView("/");
      // window.main.auth.setSession(null);  // This calls: window.main.lib.setIsLoggedin(false);
      // window.main.lib.setUserProfile({},false);
      // window.main.lib.triggerMainState();
      // // window.setTimeout(()=>{window.main.auth.checkSession(true,true)}, 1);  // Running inside a timeout prevents useState change repaint from affecting this workflow.
    },
  });
  return (null);

};

export default Logout;
